import React, { FC, useEffect } from 'react';
import CoverPopoverMenu from '../components/CoverPopoverMenu';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import {
	Platform,
	CoverItem,
	PopOverSceneItemData,
	SceneItemCoverConnection,
	SceneItemData,
} from 'sofa-reborn-react';
import { setSceneItemCover, setColorForAll } from '../store/scene';
import { ProductUtils } from '../util/ProductUtils';
/*eslint-disable */
import { ProductData, Product } from '@ikea-aoa/component-view-3d';
/* eslint-enable */

const CoverPopoverMenuContainer: FC = () => {
	const covers = useSelector<RootState, CoverItem[]>((state) => state.cover.coverItems);
	const coverOnlyItems = useSelector<RootState, CoverItem[]>((state) => state.cover.coverOnlyItems);
	const coverOnly = useSelector<RootState, boolean | undefined>((state) => state.cover.coverOnly);
	const replaceCovers = useSelector<RootState, CoverItem[]>(
		(state) => state.cover.replaceCoverItems
	);
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const missingCover = useSelector<RootState, boolean>((state) => state.cover.missingCover);
	const sceneItems = useSelector<RootState, SceneItemData[]>((state) => state.scene.sceneItems);
	const ProductData = useSelector<RootState, ProductData>((state) => state.products.products);
	const selectedSceneItem = useSelector<RootState, PopOverSceneItemData>(
		(state) => state.scene.selectedSceneItem as PopOverSceneItemData
	);
	const sceneItemCover = useSelector<RootState, SceneItemCoverConnection>(
		(state) => state.scene.setSceneItemCover as SceneItemCoverConnection
	);
	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		return (): void => {
			dispatch(setSceneItemCover(null));
			dispatch(setColorForAll(null));
		};
	}, []);

	const product =
		selectedSceneItem &&
		Object.values(ProductData).find((product) => {
			return product.productId === selectedSceneItem.articleId;
		});

	const products: Product[] = [];
	const productModelIds: string[] = [];
	Object.values(ProductData).forEach((product) => {
		sceneItems.forEach((item) => {
			if (product.productId === item.articleId) {
				products.push(product);
				productModelIds.push(product.modelId);
			}
		});
	});

	const coverItems = product
		? ProductUtils.getAllAvailableCovers(ProductData, covers, [product.modelId])
		: ProductUtils.getAllAvailableCovers(ProductData, covers, productModelIds);
	const selectCover = product
		? covers.find((cover) => cover.coverName === product.filter.color)
		: covers.find((cover) => cover.coverName === products[0].filter.color);

	const onCoverClick = (coverItem: CoverItem): void => {
		selectedSceneItem
			? dispatch(setSceneItemCover({ sceneItem: selectedSceneItem, coverItem: coverItem }))
			: dispatch(setColorForAll(coverItem.coverName));
	};

	return (
		<CoverPopoverMenu
			platform={platform}
			covers={coverOnly ? coverOnlyItems : coverItems}
			replaceCovers={replaceCovers}
			missingCover={missingCover}
			selectedCover={(sceneItemCover && sceneItemCover.coverItem) || selectCover}
			onCoverClick={(coverItem: CoverItem): void => {
				onCoverClick(coverItem);
			}}
		></CoverPopoverMenu>
	);
};

export default CoverPopoverMenuContainer;
